import React from 'react'
import { withStyles, Button } from '@material-ui/core'
import { Loading } from './Loading'

const styles = theme => ({
  container: {
    display: 'flex',
    alignItems: 'center'
  }
})

export const SubmitButtonBase = ({ classes, isSubmitting, onClick }) => (
  <div className={classes.container}>
    {isSubmitting && <Loading size={16} />}
    <Button
      variant="contained"
      color="primary"
      disabled={isSubmitting}
      onClick={onClick}
    >
      Conferma
    </Button>
  </div>
)

export const SubmitButton = withStyles(styles)(SubmitButtonBase)
